module.exports = "pegasus_template/assets/themelp1/health/105.png";